import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'
import { hashKey, QueryClient } from '@tanstack/react-query'
import { Json } from 'ox'

/** Shared React Query client for the app shell. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 60 * 24,
      queryKeyHashFn: (key) => hashKey(JSON.parse(Json.stringify(key))),
    },
  },
})

/** Shared localStorage persister for React Query state. */
export const persister = createSyncStoragePersister({
  storage: globalThis.localStorage,
  serialize: (data) => Json.stringify(data),
  deserialize: (data) => Json.parse(data),
})
